<template>
  <div>
    <el-button type="primary"
               @click="submitHandle()"
               :loading="loading">提交</el-button>
  </div>
</template>
<script>
export default {
  data () {
    return {
      loading: false
    }
  },
  methods: {
    submitHandle () {
      this.loading = true
      this.$http(`/front/cross/commodity-user/app/category-list`)
        .then(() => { })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
